// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoJsPlayer_container__2UZOU"};